import React from 'react';
import { Instagram, Facebook, Youtube, Linkedin, ArrowUp } from 'lucide-react';
import Logo from './Logo';
import { CONTACT, NAV_LINKS } from '../mock';

export default function Footer() {
  return (
    <footer className="relative bg-[#0d1519] text-[#ede2c4] pt-16 pb-8">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-[#ede2c4]/10">
          <div className="md:col-span-5">
            <div className="flex items-center mb-6">
              <Logo variant="wordmark-light" className="h-24 w-32 object-contain scale-[1.6] origin-left" />
            </div>
            <p className="text-[15px] leading-relaxed text-[#ede2c4]/60 max-w-md">
              A creative marketing house from Kochi, blending cinematic storytelling with strategic branding since 2022.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#ede2c4]/40 mb-5">Explore</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}><a href={l.href} className="text-[15px] hover:text-[#ddc390] transition-colors">{l.label}</a></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#ede2c4]/40 mb-5">Get in Touch</div>
            <ul className="space-y-3 text-[15px]">
              <li><a href={`tel:${CONTACT.phoneRaw}`} className="hover:text-[#ddc390] transition-colors">{CONTACT.phone}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-[#ddc390] transition-colors">{CONTACT.email}</a></li>
              <li className="text-[#ede2c4]/60">{CONTACT.address}, {CONTACT.city}</li>
            </ul>
            <div className="mt-6 flex items-center gap-2">
              {[Instagram, Facebook, Youtube, Linkedin].map((Icon, i) => (
                <a key={i} href="#" aria-label="social" className="h-10 w-10 rounded-full border border-[#ede2c4]/15 flex items-center justify-center hover:bg-[#ddc390] hover:text-[#162028] hover:border-transparent transition-colors">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-6 flex flex-wrap items-center justify-between gap-4">
          <div className="text-[12px] text-[#ede2c4]/50">© {new Date().getFullYear()} Rabbit Box Ads — All Rights Reserved.</div>
          <div className="flex items-center gap-5 text-[12px] text-[#ede2c4]/50">
            <a href="#" className="hover:text-[#ede2c4]">Privacy</a>
            <a href="#" className="hover:text-[#ede2c4]">Terms</a>
            <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="inline-flex items-center gap-1.5 hover:text-[#ddc390] transition-colors">
              Back to top <ArrowUp size={13} />
            </button>
          </div>
        </div>

        {/* Huge word */}
        <div className="mt-14 -mb-6 select-none">
          <div className="font-serif-display text-[16vw] md:text-[13vw] leading-[0.85] tracking-tighter text-[#ede2c4]/[0.06]">
            RabbitBox<span className="italic text-[#ddc390]/20">.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
